import { type RowData, Subscribe } from '@tanstack/react-table';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

import type { SortableHeaderProps } from '../types';

import { Button } from '@/components/ui/button';

export const SortableHeader = <TData extends RowData, TValue>(
  props: SortableHeaderProps<TData, TValue>,
) => {
  const { column, children } = props;
  return (
    <Button
      variant="ghost"
      onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
      className="text-subtle-foreground hover:text-foreground focus-visible:text-foreground text-overline h-auto w-full justify-between p-0 font-medium uppercase hover:bg-transparent focus-visible:ring-0 has-[>svg]:px-0"
    >
      {children}
      <Subscribe
        source={column.table.atoms.sorting}
        selector={(sorting) => sorting.find((item) => item.id === column.id)}
      >
        {(sort) => {
          if (!sort) {
            return <ArrowUpDown className="ml-2 size-4 opacity-50" />;
          }
          return sort.desc ? (
            <ArrowDown className="text-link ml-2 size-4" />
          ) : (
            <ArrowUp className="text-link ml-2 size-4" />
          );
        }}
      </Subscribe>
    </Button>
  );
};
